module.exports = __webpack_public_path__ + "static/media/contact-phone.15e6bc72.svg";